module.exports = __webpack_public_path__ + "img/upload-ticket.9d6f775a.png";